import type { SVGProps } from "react";
// generated from Info.svg — do not edit manually
// prettier-ignore
export default function Info(props: SVGProps<SVGSVGElement>) {
  return (<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" {...props}><path d="M 12 16 V 11 M 12 7 V 9 M 22 12 C 22 6.4772 17.523 2 12 2 C 6.477 2 2 6.4772 2 12 C 2 17.5228 6.477 22 12 22 C 17.523 22 22 17.5228 22 12 Z" stroke="currentColor" strokeWidth="1.5"/></svg>);
}
